import React, { useState } from 'react';
import { Navigate } from "react-router-dom";

import Grid from '@mui/material/Grid2';

import { FeatureSource, ModelBase } from "@models";
import { 
  Gift, 
} from "@dndModels";

import StringBox from "@components/input/strings/StringBox";
import CheckBox from "@components/input/CheckBox";

import FeatureSourceInput from "@dndComponents/FeatureSourceInput";

import API from "@dndUtilities/system_api";
import CommonUtilities from "@utilities/common_utilities";
import SuggestionStringBox from "@dndComponents/select/SuggestionStringBox";

const api = API.getInstance();
const common_util = CommonUtilities.getInstance();

interface Props {
  obj?: ModelBase;
}

export default function GiftEdit({ obj: param_obj }: Props) {
  const [navigateTo, setNavigateTo] = useState<string | null>(null);
  const [obj, setObj] = useState<Gift>(param_obj instanceof Gift ? param_obj : api.applyWorkingOn(new Gift()));
  const [change_time, setChangeTime] = useState(0);
  const [tab, setTab] = useState("Description");
  
  const disabled = api.user === null || !api.online || (!api.user.admin && obj._id !== "" && obj.owner_id !== api.user._id);
  
  const height = window.innerHeight - 64;
  if (navigateTo !== null) {
    return <Navigate to={navigateTo} />;
  } else { 
    // console.log(obj);
    return (
      <div style={{ height }}>
        <Grid container spacing={0} direction="row" style={{ height: "100%" }}>
          <Grid
            container
            spacing={0}
            direction="row"
            style={{ height: (tab === "Description" ? (height - 61) : height) }}
            size={12}>
            <Grid
              style={{ height: "100%" }}
              size={12}>
              <FeatureSourceInput 
                obj={obj}
                data_type="gift"
                disabled={disabled}
                change_time={change_time}
                onChange={(changed: FeatureSource) => {
                  if (changed instanceof Gift) {
                    const new_obj = obj;
                    new_obj.copy(changed);
                    setObj(new_obj);
                  }
                }}
                onTabChange={(changed: string) => {
                  setTab(changed);
                }}
              >
                <Grid container spacing={0} direction="row">
                  <Grid
                    size={{
                      xs: 12
                    }}>
                    <SuggestionStringBox 
                      name="Type"
                      field="gift_type"
                      value={obj.type} 
                      disabled={disabled}
                      onChange={(changed: string) => {
                        const new_obj = obj;
                        new_obj.type = changed;
                        setObj(new_obj);
                        setChangeTime(common_util.get_time_number());
                      }}
                    />
                  </Grid>
                  <Grid
                    size={{
                      xs: obj.use_gift_levels ? 6 : 12
                    }}>
                    <CheckBox name="Use Gift Levels"
                      value={obj.use_gift_levels} 
                      disabled={disabled}
                      onChange={(value: boolean) => {
                        const new_obj = obj;
                        new_obj.use_gift_levels = value;
                        setObj(new_obj);
                        setChangeTime(common_util.get_time_number());
                      }}
                    />
                  </Grid>
                  { obj.use_gift_levels &&
                    <Grid
                      size={{
                        xs: 6
                      }}>
                      <StringBox 
                        name="Max Level"
                        value={`${obj.max_level}`} 
                        type="number"
                        onBlur={(value: string) => {
                          const new_obj = obj;
                          new_obj.max_level = +value;
                          setObj(new_obj);
                          setChangeTime(common_util.get_time_number());
                        }}
                      />
                    </Grid>
                  }
                </Grid>
              </FeatureSourceInput>
            </Grid>
          </Grid>
        </Grid>
      </div>
    ); 
  }
}